"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ApiCoreRouterComponent", {
  enumerable: true,
  get: function get() {
    return _routers.default;
  }
});
var _routers = _interopRequireDefault(require("./components/routers"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }